import { Link, useSearchParams } from 'react-router-dom';
import { Breadcrumb, Layout, theme } from 'antd';

import { PageLayout } from '@app/web-components';

import { CreateForm } from '../forms';

import { TITLE } from './landing';

export const CreatePage = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const [searchParams] = useSearchParams();

  return (
    <>
      <Breadcrumb
        style={{ margin: '16px 0' }}
        items={[
          { title: <Link to="/">Home</Link> },
          { title: 'Admin' },
          { title: 'Maps' },
          { title: <Link to="../">{TITLE}</Link> },
          { title: 'Create' },
        ]}
      />
      <Layout.Content
        style={{
          padding: 24,
          margin: 'auto',
          height: '100%',
          width: '100%',
          maxWidth: 1200,
          minHeight: 0,
          background: colorBgContainer,
          overflow: 'auto',
        }}
      >
        <PageLayout.Title title="Map Supplier Attribute" />
        <CreateForm supplierId={searchParams.get('id')} supplierName={searchParams.get('name')} />
      </Layout.Content>
    </>
  );
};
